export default {
  inserted(el, binding) {
    const options = {
      root: binding.arg?.el ? document.querySelector(binding.arg.el) : null, // Use a custom viewport if provided
      rootMargin: '0px', // margin around root
      threshold: binding.arg?.threshold ?? 0.05, // trigger when 5% of the element is visible if threshold is not provided
    }

    const callback = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          binding.value(el, true) // element is in the viewport
        } else {
          binding.value(el, false) // element is out of the viewport
        }
      })
    }

    const observer = new IntersectionObserver(callback, options)
    observer.observe(el)

    el._v_observer = observer // store the observer on the element for later unobserving
  },
  unbind(el) {
    el._v_observer.disconnect() // disconnect the observer when the element is unbound
  },
}
